import MatchedMap from 'utilities/src/matchedMap';

import { ThemeEnum, useTheme } from 'ui/src/components/Theme';

import footerCommonTheme from './common';

import footerBlogTheme from './_blog';
import footerSiteTheme from './_site';

const footerThemes = new MatchedMap([
  [ThemeEnum.Blog, footerBlogTheme],
  [ThemeEnum.Site, footerSiteTheme],
]);

const useFooterTheme = () => useTheme(footerCommonTheme, footerThemes);

export default useFooterTheme;
